import useOrgchartAreasStore from "./store";

const useSearchedNodesStyles = (
  nodeId: string
): { border: string; opacity: number } => {
  const { searchedNodeId } = useOrgchartAreasStore();

  if (!searchedNodeId) {
    return { border: "1px solid rgba(33, 150, 243, 0.50)", opacity: 1 };
  }

  if (searchedNodeId === nodeId) {
    return { border: "4px solid #42A5F5", opacity: 1 };
  }

  return { border: "1px solid rgba(33, 150, 243, 0.50)", opacity: 0.4 };
};

export default useSearchedNodesStyles;
